import script from "./ReportEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportEdit.vue?vue&type=script&setup=true&lang=js"

import "./ReportEdit.vue?vue&type=style&index=0&id=2bc7e3cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc7e3cb"]])

export default __exports__